<template>
  <div class="trading-competition-card">
    <div
      class="trading-competition-card__container bor--radius-10 flx flx--col bg--color-02 sha--03"
    >
      <!-- TOP  BLOCK -->
      <div
        class="trading-competition-card__top-block flx pt-30 pb-28 pl-14 pr-14 p-24--l"
      >
        <div class="trading-competition-card__coin-block">
          <div class="trading-competition-card__coin-img mb-8 mb-4--l">
            <img
              :src="
                comp.logo ||
                  require('@/assets/icons/trading-competition/default-icon.svg')
              "
              alt="coin icon"
            >
          </div>
          <span
            class="trading-competition-card__coin-name txt--bold txt--color-04 txt--16px txt--22px txt--height-20px txt--height-30px--l"
          >
            {{ comp.ticker }}, {{ getCurrencyFullName(comp.ticker) }}
          </span>
        </div>
        <div class="trading-competition-card__reward-img flx">
          <img :src="require('@/assets/img/rewards/cup-gold.svg')">
        </div>
      </div>

      <!-- BOTTOM  BLOCK -->
      <div
        class="trading-competition-card__bottom-block bg--color-01 flx flx--col pt-18 pl-14 pr-14 pb-18 p-24--l"
      >
        <!-- SLIDER BLOCK -->
        <div
          class="trading-competition-card__reward-block flx flx--content-between flx--items-start mb-24"
        >
          <div class="trading-competition-card__reward">
            <div class="trading-competition-card__reward-value">
              <span
                class="txt--weight-500 txt--14px txt--16px--l txt--height-18px txt--height-20px--l mb-2"
              >
                {{ comp.bestPrize | formatNumber({ decimal: 4 }) }}
                {{ comp.prizeTicker }}
              </span>
            </div>
            <div class="trading-competition-card__note">
              <span class="txt--bold txt--16px txt--height-20px txt--color-04">
                {{ $t('tradingCompetition.card.bestPrize') }}
              </span>
            </div>
          </div>
          <div
            class="trading-competition-card__status-block flx flx--items-center"
          >
            <div
              class="trading-competition-card__status-dot"
              :class="`bg--${status.color}`"
            />
            <span
              class="trading-competition-card__status-name ml-6"
              :class="`txt--${status.color}`"
            >
              {{ status.text }}
            </span>
          </div>
        </div>

        <!-- BUTTONS -->
        <div class="trading-competition-card__buttons">
          <div
            class="trading-competition-card__buttons-container"
            @click.prevent
          >
            <exc-button
              size="s"
              full-width
              :to="localePath(`/trading-competition/plan/${comp.ticker}`)"
            >
              <span class="txt--uppercase">
                {{ $t('tradingCompetition.start') }}
              </span>
            </exc-button>
            <exc-base-dropdown
              :value="selectedPair"
              :options="comp.dropdownOptions"
              :open-up="dropdownOpenUp"
              size="s"
              full-width
              dropdown-on-hover
              search-by="name"
            >
              <template #selected="{ option }">
                <span class="txt--color-03">
                  {{ option.name }}
                </span>
              </template>
              <template #item="slotProps">
                <span @click="pushToTrade(slotProps.option.pairName)">
                  <exc-dropdown-item v-bind="slotProps" />
                </span>
              </template>
            </exc-base-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { TradingCompetitionModel } from '@/lib/data-models/trading-competition/TradingCompetitionModel.ts'
import {
  ExcBaseDropdown,
  ExcButton,
  ExcDropdownItem,
} from '@/components/common'

export default {
  name: 'TradingCompetitionCard',
  components: {
    ExcButton,
    ExcBaseDropdown,
    ExcDropdownItem,
  },
  props: {
    comp: { type: TradingCompetitionModel, required: true },
    dropdownOpenUp: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      getCurrencyFullName: 'pairs/getCurrencyFullName',
    }),
    selectedPair () {
      return { name: this.$t('tradingCompetition.trade') }
    },
    status () {
      const colors = {
        ACTIVE: 'green',
        FINISHED: 'grey',
        PENDING: 'color-09',
      }

      return {
        color: colors[this.comp.status],
        text: this.$t(
          `tradingCompetition.statuses.${this.comp.status.toLowerCase()}`,
        ),
      }
    },
  },
  methods: {
    pushToTrade (pairName) {
      const [left, right] = pairName.split('_')

      this.localePush(`/exchange/${left}/${right}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.trading-competition-card {
  &__top-block {
    justify-content: space-between;
    gap: toRem(26px);
  }

  &__coin-block {
    flex: 1;
  }

  &__coin-img {
    img {
      height: toRem(42px);
      width: toRem(42px);

      @include bp(l) {
        height: toRem(48px);
        width: toRem(48px);
      }
    }
  }

  &__reward-img {
    flex: 1;

    img {
      margin-left: auto;
    }
  }

  &__status-dot {
    width: toRem(6px);
    height: toRem(6px);
    border-radius: 50%;
  }

  &__bottom-block {
    box-shadow: 0px -4px 10px rgba(57, 81, 129, 0.05);
    border-radius: 0 0 toRem(10px) toRem(10px);
  }

  &__buttons {
    width: 100%;
  }

  &__buttons-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: toRem(12px);
    justify-content: space-between;
  }
}
</style>
